
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-sheets",
      function () {
        return require("private-next-pages/destinations/google-sheets.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-sheets"])
      });
    }
  